import { render, staticRenderFns } from "./Return.vue?vue&type=template&id=acf437ba&scoped=true&"
import script from "./Return.vue?vue&type=script&lang=ts&"
export * from "./Return.vue?vue&type=script&lang=ts&"
import style0 from "./Return.vue?vue&type=style&index=0&id=acf437ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf437ba",
  null
  
)

export default component.exports